import {Button, Form} from 'react-bootstrap'
import {TFormAllValues} from '../../../policies/policiesTypes'
import {FormikErrors, FormikTouched} from 'formik'
import {useSearchParams} from 'react-router-dom'
import {MembersEdit} from './MembersEdit'
import { INIT_FORM_MEMBERS } from '../../../../helpers/consts'

interface IFamiliMemsProps {
  onPrevStep: () => void
  onNextStep: () => void
  handleChange: (field: string, value: string | boolean) => void
  handleBlur: (field: string) => void
  addMember: () => void
  removeMember: (index: number) => void
  allValues: TFormAllValues
  errors: FormikErrors<TFormAllValues>
  touched: FormikTouched<TFormAllValues>
  loadingCreate: boolean
  isDisableEdit?: boolean
  onSwitchWithHolder: (index: number) => void   // 👈 NUEVO
  isQuote: boolean
}

export const FamilyMembersTab: React.FC<IFamiliMemsProps> = ({
  onPrevStep,
  onNextStep,
  allValues,
  errors,
  touched,
  handleChange,
  handleBlur,
  addMember,
  removeMember,
  loadingCreate,
  isDisableEdit = false,
  onSwitchWithHolder,
  isQuote,
}) => {
  const [searchParams] = useSearchParams()
  const lead = searchParams.get('lead')

  return (
    <div className='family-members-container'>
      <div className='kt-heading kt-heading--md custom-border-brand'>
        Applicants &amp; Dependents
      </div>
      {lead && Number(lead) ? (
        <div className='mt-6'>
          <Form.Group>
            <Form.Label>Find and select a contact</Form.Label>
            <Form.Text style={{fontSize: '12px'}}>
              Search by name, email address, phone number or last 4 digits of SSN
            </Form.Text>
          </Form.Group>
        </div>
      ) : (
        <>
          <div className='list-member'>
            {allValues.policyMembers && allValues.policyMembers.length > 0 && (
              <div>
                <h4 className='mb-5 mt-5'>Members ({allValues.policyMembers.length})</h4>
                {allValues.policyMembers.map((value, index) => {
                  // console.log('Renderizando miembro:', index, value)
                  return (
                    <MembersEdit
                      key={value.id || `new-${index}`}
                      membernum={index}
                      allValues={allValues}
                      valuesMembers={value}
                      errors={
                        (errors.policyMembers?.[index] ?? {}) as FormikErrors<
                          typeof INIT_FORM_MEMBERS
                        >
                      }
                      touched={
                        (touched.policyMembers?.[index] ?? {}) as FormikTouched<
                          typeof INIT_FORM_MEMBERS
                        >
                      }
                      handleChange={(field, value) =>
                        handleChange(`policyMembers[${index}].${field}`, value)
                      }
                      handleBlur={(field) => handleBlur(`policyMembers[${index}].${field}`)}
                      // handleChange={handleChange}
                      removeMember={removeMember}
                      onSwitchWithHolder={onSwitchWithHolder}
                      isQuote={isQuote}
                    />
                  )
                })}
              </div>
            )}
          </div>
          <div className='mt-5 d-flex align-items-center justify-content-center'>
            <span
              style={{
                width: '100%',
                height: '2px',
                flex: 1,
                background: '#c7c7c7',
                display: 'inline-block',
              }}
            />
            <h5 className='ms-3 me-3 mt-0 mb-0' style={{fontSize: '14px'}}>
              Add below the information of each Member
            </h5>
            <span
              style={{
                width: '100%',
                height: '2px',
                flex: 1,
                background: '#c7c7c7',
                display: 'inline-block',
              }}
            />
          </div>
          <div className='mt-5 mb-5 pb-6'>
            <Button
              variant='success'
              size='sm'
              onClick={(e) => {
                e.preventDefault()
                addMember()
              }}
            >
              <i className='bi bi-plus' />
              Add member
            </Button>
          </div>
        </>
      )}
      <div className='btn-prev-next'>
        <Button size='sm' variant='secondary' onClick={onPrevStep}>
          PREVIOUS
        </Button>
        <Button size='sm' onClick={onNextStep}>
          NEXT STEP
        </Button>
      </div>
    </div>
  )
}
